module.exports = __webpack_public_path__ + "static/media/user.893f9ea8.svg";